import React from 'react';
import { motion } from 'framer-motion';
import { HERO_IMAGE_URL, LOGO_URL, PHONE_HREF } from '../data/site';
import { PinIcon } from './icons/Icons';
import { useLanguage } from '../data/i18n';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section id="top" className="relative min-h-[100svh] w-full overflow-hidden grain bg-black" data-id="element-65" data-mp="9ipd9eps7k1p">
      <div className="absolute inset-0" data-id="element-66" data-mp="4jm69oq8r3r3">
        <img src={HERO_IMAGE_URL} alt="" aria-hidden="true" className="h-full w-full object-cover object-center grayscale contrast-125 opacity-60" data-id="element-67" data-mp="12a0j75mcfqrz" />
        <div className="absolute inset-0 bg-black/70" data-id="element-68" data-mp="xb5whsl99i2l"><motion.img initial={{
          opacity: 0,
          scale: 0.92
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.9,
          ease: [0.22, 1, 0.36, 1]
        }} src={LOGO_URL} alt="Logo DuvayBarberVIP — Duvay Gang Annibale, Marbs VIP Club" className="h-32 w-32 sm:h-40 sm:w-40 rounded-full object-cover grayscale contrast-150 ring-1 ring-white/40" style={{
          width: "105px",
          height: "100px"
        }} data-id="element-69" data-mp="saruar6c52ch" /></div>
        <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent" data-id="element-70" data-mp="3j7zhlpe3m4ju" />
      </div>

      <div className="relative z-10 mx-auto flex min-h-[100svh] max-w-5xl flex-col items-center justify-center px-6 pt-28 pb-20 text-center" data-id="element-71" data-mp="3o6kfvj9sie5n">
        

        <motion.p initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="mt-10 font-sans text-[10px] sm:text-xs uppercase tracking-[0.4em] text-ash" data-id="element-72" data-mp="39cpain8uf6z7">
          {t.hero.eyebrow}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="mt-5 font-display text-[15vw] leading-[0.85] tracking-[0.04em] text-bone sm:text-8xl lg:text-9xl" data-id="element-73" data-mp="2qkdc2blb8puc">
          DUVAY<span className="text-white/45" data-id="element-74" data-mp="2ll0eowwtc0di">BARBER</span>VIP
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.45
      }} className="mt-8 max-w-2xl font-body text-base sm:text-lg font-light italic leading-relaxed text-white/75" data-id="element-75" data-mp="s21k8hdb6o2m">
          {t.hero.quote}
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="mt-12 flex flex-col sm:flex-row items-center gap-4" data-id="element-76" data-mp="degeefp1uar0">
          <a href="#reserva" className="w-full sm:w-auto bg-white px-10 py-4 font-sans text-[11px] uppercase tracking-[0.3em] text-black hover:bg-white/85 transition-colors" data-id="element-77" data-mp="112g55fmd215l">
            {t.hero.ctaPrimary}
          </a>
          <a href={PHONE_HREF} className="w-full sm:w-auto border border-white/40 px-10 py-4 font-sans text-[11px] uppercase tracking-[0.3em] text-bone hover:bg-white hover:text-black transition-colors" data-id="element-78" data-mp="3lt76ct9j5vvb">
            {t.hero.ctaSecondary}
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 0.9
      }} className="mt-14 flex items-center gap-2 font-sans text-[10px] uppercase tracking-[0.3em] text-ash" data-id="element-79" data-mp="21awdua25atgy">
          <PinIcon className="w-4 h-4" data-id="element-80" data-mp="2b20qv489g495" />
          Av. Arias de Velasco 13 · Marbella
        </motion.div>
      </div>
    </section>;
}